<template>
    <router-view :props="props" ref="view"></router-view>
</template>

<script>
import {mapGetters, mapMutations, mapState} from "vuex";

    export default {
        created(){
            window.addEventListener('keyup', this.handleNextPrevKeypress)
        },
        beforeDestroy() {
            window.removeEventListener('keyup', this.handleNextPrevKeypress)
        },
        props: [
            'props'
        ],
        computed: {
            ...mapGetters({
                currentNextPrev: 'auction_nextprev/current',
            }),
            ...mapState({
                single_vehicle: state => state.auction_search.single_vehicle,
                single_next: state => state.auction_search.single_next,
                single_prev: state => state.auction_search.single_prev,
            }),
        },
        watch:{
            $route (to, fromRoute){
                //set new title
                if (to.meta && to.meta.title) {
                    let title = typeof to.meta.title === 'function' ? to.meta.title() : to.meta.title;
                    document.title = title;
                }

                //change body class
                if (document.body.classList && document.body.classList.length) {
                    document.body.classList.forEach(className => {
                        if (className.match(/^route-/)) {
                            document.body.classList.remove(className);
                        }
                    });
                }
                if (to.name) {
                    let toClass = 'route-'+to.name.replace(/([^a-zA-Z-_])/, '-');
                    document.body.classList.add(toClass);
                }

                if (to.query && to.query.iframe) {
                    document.body.classList.add('iframe');
                } else {
                    document.body.classList.remove('iframe');
                }
            }
        },
        methods: {
            ...mapMutations({
                setSingleNext: 'auction_search/setSingleNext',
                setSinglePrev: 'auction_search/setSinglePrev',
                setSingleVehicle: 'auction_search/setSingleVehicle',
            }),
            async handleVehicleNextPrev(next) {
                const processUrl = url => {
                    if (this.$route.query.state_key) {
                        if (url.indexOf('?') === -1) {
                            url = url + '?state_key=' + this.$route.query.state_key
                        } else {
                            url = url + '&state_key=' + this.$route.query.state_key
                        }
                    }
                    return url
                }
                if (next) {
                    if (this.single_next && this.single_next.api_id === this.next_id()) {
                        let url = processUrl(this.single_next.detail_url)
                        this.setSinglePrev(this.result)
                        this.setSingleVehicle(this.single_next);
                        await this.$router.push(url);
                    } else {
                        let url = processUrl('/search/' + this.next_id())
                        await this.$router.push(url);
                    }
                } else {
                    if (this.single_prev && this.single_prev.api_id === this.prev_id()) {
                        let url = processUrl(this.single_prev.detail_url)
                        this.setSingleNext(this.result)
                        this.setSingleVehicle(this.single_prev);
                        await this.$router.push(url);
                    } else {
                        let url = processUrl('/search/' + this.prev_id())
                        await this.$router.push(url);
                    }
                }
            },

            handleNextPrevKeypress(e) {
                if (this.$route.name !== 'vehicle-detail'){
                    return;
                }
                if (this.currentNextPrev) {
                    let fancebox_open = $('.fancybox-is-open').length
                    if (fancebox_open) {
                        return;
                    }
                    if (e.keyCode) {
                        const isLeftRight = e.keyCode === 37 //left
                            || e.keyCode === 39 //right
                        if (!$(e.target).is(':input')) {
                            if (isLeftRight) {
                                this.handleVehicleNextPrev(e.keyCode === 39);
                            }
                        } else if (($(e.target).is('#bidPrice') || $(e.target).is('#estimatedLandedCost')) && $(e.target).val() === '') {
                            if (isLeftRight) {
                                this.handleVehicleNextPrev(e.keyCode === 39);
                            }
                        }
                    }
                }
            },
            getNextPrevId(next = true) {
                if (!this.currentNextPrev) {
                    return;
                }
                let id = null;
                let current = parseInt(this.$route.params.id);
                let i = this.currentNextPrev.ids.indexOf(current);
                if (i !== -1) {
                    if (next) {
                        if ((i+1) === this.currentNextPrev.ids.length) {
                            id = this.currentNextPrev.ids[0];
                        } else {
                            id = this.currentNextPrev.ids[i+1];
                        }
                    } else {
                        if ((i-1) === -1) {
                            id = this.currentNextPrev.ids[this.currentNextPrev.ids.length - 1];
                        } else {
                            id = this.currentNextPrev.ids[i-1];
                        }
                    }
                }
                return id;
            },

            next_id(){
                return this.getNextPrevId(true)
            },
            prev_id(){
                return this.getNextPrevId(false)
            },
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/RouterPage.vue